(function () {
  'use strict';

  if (window.__kkProductPageControllersInitialized) {
    return;
  }

  window.__kkProductPageControllersInitialized = true;

  var gallerySelector = '[data-product-gallery][data-gallery-progressive-loading]';
  var stableGallerySelector = '[data-product-gallery][data-kk-gallery-stable]';
  var deferredImageSelector = '[data-rimg="gallery-deferred"]';
  var initializedGalleries = new WeakSet();
  var pendingFigures = new WeakSet();
  var galleryObservers = new WeakMap();
  var galleryGeometryStates = new WeakMap();
  var thumbnailRovingStates = new WeakMap();
  var quickshopObservers = new WeakMap();
  var photoSwipeFocusGuardDialogs = new WeakSet();
  var tabStates = new WeakMap();
  var tabInitTimers = new WeakMap();
  var tooltipInitialized = false;

  function toArray(collection) {
    return Array.prototype.slice.call(collection || []);
  }

  function eachWithin(root, selector, callback) {
    if (!root) {
      return;
    }

    if (root.nodeType === 1 && root.matches(selector)) {
      callback(root);
    }

    if (root.querySelectorAll) {
      toArray(root.querySelectorAll(selector)).forEach(callback);
    }
  }

  /* Stable first-paint product-gallery geometry */
  function clearGalleryGeometryFrames(state) {
    if (state.readyFrame !== null) {
      window.cancelAnimationFrame(state.readyFrame);
      state.readyFrame = null;
    }
    if (state.settleFrame !== null) {
      window.cancelAnimationFrame(state.settleFrame);
      state.settleFrame = null;
    }
  }

  function finishGalleryInitialGeometry(gallery, state) {
    var navigation = state.navigation;
    var viewer;
    var selectedFigure;

    state.settleFrame = null;
    if (
      !document.documentElement.contains(gallery) ||
      (navigation && navigation.classList.contains('loading'))
    ) {
      return;
    }

    viewer = gallery.querySelector('[data-gallery-viewer]');
    selectedFigure = viewer && viewer.querySelector(
      '[data-gallery-figure][data-gallery-selected="true"]'
    );

    if (
      viewer &&
      selectedFigure &&
      selectedFigure.getAttribute('data-media-type') === 'image' &&
      !state.mediaChanged
    ) {
      /* The Liquid aspect ratio owns the initial image height. */
      viewer.style.removeProperty('height');
      gallery.classList.add('kk-gallery-initial-image');
    }

    gallery.classList.add('kk-gallery-ready');
  }

  function scheduleGalleryInitialGeometry(gallery, state) {
    if (
      gallery.classList.contains('kk-gallery-ready') ||
      state.readyFrame !== null ||
      state.settleFrame !== null ||
      (state.navigation && state.navigation.classList.contains('loading'))
    ) {
      return;
    }

    state.readyFrame = window.requestAnimationFrame(function () {
      state.readyFrame = null;
      state.settleFrame = window.requestAnimationFrame(function () {
        finishGalleryInitialGeometry(gallery, state);
      });
    });
  }

  function initializeGalleryGeometry(gallery) {
    var navigation;
    var viewer;
    var selectedFigure;
    var state;

    if (galleryGeometryStates.has(gallery)) {
      return;
    }

    navigation = gallery.querySelector('[data-gallery-navigation]');
    viewer = gallery.querySelector('[data-gallery-viewer]');
    selectedFigure = viewer && viewer.querySelector(
      '[data-gallery-figure][data-gallery-selected="true"]'
    );
    state = {
      navigation: navigation,
      navigationObserver: null,
      selectionObserver: null,
      initialMediaId: selectedFigure && selectedFigure.getAttribute('data-media'),
      mediaChanged: false,
      readyFrame: null,
      settleFrame: null
    };

    if (navigation) {
      state.navigationObserver = new MutationObserver(function () {
        scheduleGalleryInitialGeometry(gallery, state);
      });
      state.navigationObserver.observe(navigation, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    if (viewer) {
      state.selectionObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          var figure = mutation.target;

          if (
            figure instanceof HTMLElement &&
            figure.matches('[data-gallery-figure][data-gallery-selected="true"]') &&
            figure.getAttribute('data-media') !== state.initialMediaId
          ) {
            state.mediaChanged = true;
            gallery.classList.remove('kk-gallery-initial-image');
          }
        });
      });
      state.selectionObserver.observe(viewer, {
        attributes: true,
        subtree: true,
        attributeFilter: ['data-gallery-selected']
      });
    }

    galleryGeometryStates.set(gallery, state);
    scheduleGalleryInitialGeometry(gallery, state);
  }

  function initializeGalleryGeometryWithin(root) {
    eachWithin(root, stableGallerySelector, initializeGalleryGeometry);
  }

  function unloadGalleryGeometryWithin(root) {
    eachWithin(root, stableGallerySelector, function (gallery) {
      var state = galleryGeometryStates.get(gallery);

      if (!state) {
        return;
      }

      clearGalleryGeometryFrames(state);
      if (state.navigationObserver) {
        state.navigationObserver.disconnect();
      }
      if (state.selectionObserver) {
        state.selectionObserver.disconnect();
      }
      galleryGeometryStates.delete(gallery);
    });
  }

  /* Product-gallery thumbnail roving tabindex */
  function getThumbnailButtons(container) {
    return toArray(container && container.querySelectorAll('[data-gallery-thumbnail]'));
  }

  function focusElementWithoutScroll(element) {
    if (!element || typeof element.focus !== 'function') {
      return;
    }

    try {
      element.focus({ preventScroll: true });
    } catch (error) {
      element.focus();
    }
  }

  function scrollThumbnailIntoView(container, thumbnail) {
    var containerBounds;
    var thumbnailBounds;

    if (!container || !thumbnail) {
      return;
    }

    containerBounds = container.getBoundingClientRect();
    thumbnailBounds = thumbnail.getBoundingClientRect();

    if (container.scrollHeight > container.clientHeight) {
      if (thumbnailBounds.top < containerBounds.top) {
        container.scrollTop -= containerBounds.top - thumbnailBounds.top;
      } else if (thumbnailBounds.bottom > containerBounds.bottom) {
        container.scrollTop += thumbnailBounds.bottom - containerBounds.bottom;
      }
    }

    if (container.scrollWidth > container.clientWidth) {
      if (thumbnailBounds.left < containerBounds.left) {
        container.scrollLeft -= containerBounds.left - thumbnailBounds.left;
      } else if (thumbnailBounds.right > containerBounds.right) {
        container.scrollLeft += thumbnailBounds.right - containerBounds.right;
      }
    }
  }

  function syncThumbnailRoving(container, scrollSelected) {
    var thumbnails = getThumbnailButtons(container);
    var selected = thumbnails.find(function (thumbnail) {
      return thumbnail.getAttribute('data-gallery-selected') === 'true';
    }) || thumbnails[0];

    thumbnails.forEach(function (thumbnail) {
      var isSelected = thumbnail === selected;

      thumbnail.setAttribute('tabindex', isSelected ? '0' : '-1');
      if (isSelected) {
        thumbnail.setAttribute('aria-current', 'true');
      } else {
        thumbnail.removeAttribute('aria-current');
      }
    });

    if (scrollSelected && selected) {
      scrollThumbnailIntoView(container, selected);
    }
  }

  function handleThumbnailRovingKeydown(container, event) {
    var target = event.target instanceof Element ? event.target.closest('[data-gallery-thumbnail]') : null;
    var thumbnails;
    var currentIndex;
    var nextIndex;

    if (!target || !container.contains(target) || event.altKey || event.ctrlKey || event.metaKey) {
      return;
    }

    thumbnails = getThumbnailButtons(container);
    currentIndex = thumbnails.indexOf(target);
    if (currentIndex < 0 || thumbnails.length < 2) {
      return;
    }

    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        nextIndex = (currentIndex + 1) % thumbnails.length;
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        nextIndex = (currentIndex - 1 + thumbnails.length) % thumbnails.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = thumbnails.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    event.stopPropagation();
    focusElementWithoutScroll(thumbnails[nextIndex]);
    thumbnails[nextIndex].click();
  }

  function initializeThumbnailRovingContainer(container) {
    var keydownHandler;
    var observer;

    if (!container || thumbnailRovingStates.has(container)) {
      return;
    }

    keydownHandler = function (event) {
      handleThumbnailRovingKeydown(container, event);
    };
    observer = new MutationObserver(function (mutations) {
      var shouldScroll = mutations.some(function (mutation) {
        return mutation.type === 'childList' || (
          mutation.type === 'attributes' &&
          mutation.target.getAttribute('data-gallery-selected') === 'true'
        );
      });

      syncThumbnailRoving(container, shouldScroll);
    });

    container.addEventListener('keydown', keydownHandler);
    observer.observe(container, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['data-gallery-selected']
    });
    thumbnailRovingStates.set(container, {
      keydownHandler: keydownHandler,
      observer: observer
    });
    syncThumbnailRoving(container, false);
  }

  function initializeGalleryThumbnailRoving(gallery) {
    initializeThumbnailRovingContainer(gallery.querySelector('[data-gallery-scroller]'));
  }

  function initializeGalleryThumbnailRovingWithin(root) {
    eachWithin(root, '[data-product-gallery]', initializeGalleryThumbnailRoving);
  }

  function unloadGalleryThumbnailRovingWithin(root) {
    eachWithin(root, '[data-product-gallery]', function (gallery) {
      var container = gallery.querySelector('[data-gallery-scroller]');
      var state = container && thumbnailRovingStates.get(container);

      if (!state) {
        return;
      }

      state.observer.disconnect();
      container.removeEventListener('keydown', state.keydownHandler);
      thumbnailRovingStates.delete(container);
    });
  }

  function initializePhotoSwipeThumbnailRoving() {
    initializeThumbnailRovingContainer(document.querySelector('[data-photoswipe-thumb-scroller]'));
  }

  function isAvailablePhotoSwipeFocusTarget(element) {
    var style;

    if (
      !element ||
      element.tabIndex < 0 ||
      element.disabled ||
      element.getAttribute('aria-disabled') === 'true' ||
      element.closest('[hidden], [inert], [aria-hidden="true"]')
    ) {
      return false;
    }

    style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
  }

  function initializePhotoSwipeFocusGuard() {
    var dialog = document.querySelector('[data-photoswipe]');

    if (!dialog || photoSwipeFocusGuardDialogs.has(dialog)) {
      return;
    }

    dialog.addEventListener('keydown', function (event) {
      var focusable;
      var active;
      var activeIndex;
      var target;

      if (event.key !== 'Tab' || dialog.getAttribute('aria-hidden') === 'true') {
        return;
      }

      focusable = toArray(dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), ' +
        'select:not([disabled]), textarea:not([disabled]), [tabindex]'
      )).filter(isAvailablePhotoSwipeFocusTarget);
      active = document.activeElement;
      activeIndex = focusable.indexOf(active);

      if (!focusable.length) {
        target = dialog;
      } else if (event.shiftKey && (activeIndex <= 0 || !dialog.contains(active))) {
        target = focusable[focusable.length - 1];
      } else if (!event.shiftKey && (activeIndex === focusable.length - 1 || activeIndex < 0)) {
        target = focusable[0];
      }

      if (!target) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      focusElementWithoutScroll(target);
    }, true);
    photoSwipeFocusGuardDialogs.add(dialog);
  }

  /* Progressive product gallery loading */
  function getGalleryFigures(gallery) {
    return toArray(gallery.querySelectorAll('[data-gallery-viewer] [data-gallery-figure]'));
  }

  function getGalleryImageFigures(gallery) {
    return getGalleryFigures(gallery).filter(function (figure) {
      return figure.getAttribute('data-media-type') === 'image';
    });
  }

  function promoteGalleryFigureImages(figure) {
    toArray(figure.querySelectorAll('img.product-gallery--loaded-image')).forEach(function (image) {
      image.setAttribute('loading', 'eager');
      image.setAttribute('fetchpriority', 'high');
    });
  }

  function updateGalleryViewerAspectRatio(gallery, figure) {
    var viewer;
    var ratio;

    if (gallery.getAttribute('data-product-gallery-aspect-ratio') !== 'natural') {
      return;
    }

    ratio = parseFloat(figure.getAttribute('data-media-aspect-ratio'));
    if (!isFinite(ratio) || ratio <= 0) {
      return;
    }

    viewer = gallery.querySelector('[data-gallery-viewer]');
    if (!viewer) {
      return;
    }

    viewer.style.aspectRatio = String(ratio);
    viewer.style.height = '';
  }

  function loadGalleryFigureWhenReady(figure, attempts) {
    var currentAttempts = attempts || 0;

    if (window.bcImage && typeof window.bcImage.load === 'function') {
      window.bcImage.load(figure);
      pendingFigures.delete(figure);
      return;
    }

    if (currentAttempts < 120 && document.documentElement.contains(figure)) {
      window.requestAnimationFrame(function () {
        loadGalleryFigureWhenReady(figure, currentAttempts + 1);
      });
    } else {
      pendingFigures.delete(figure);
    }
  }

  function activateGalleryFigure(figure) {
    var deferredImages;

    if (!figure) {
      return;
    }

    deferredImages = figure.querySelectorAll(deferredImageSelector);
    if (!deferredImages.length) {
      return;
    }

    toArray(deferredImages).forEach(function (image) {
      image.setAttribute('data-rimg', 'lazy');
    });

    if (!pendingFigures.has(figure)) {
      pendingFigures.add(figure);
      loadGalleryFigureWhenReady(figure);
    }
  }

  function preloadFollowingGalleryImage(gallery, currentFigure) {
    var imageFigures = getGalleryImageFigures(gallery);
    var currentIndex;
    var nextIndex;

    if (imageFigures.length < 2) {
      return;
    }

    currentIndex = imageFigures.indexOf(currentFigure);
    nextIndex = currentIndex >= 0 ? (currentIndex + 1) % imageFigures.length : 0;
    activateGalleryFigure(imageFigures[nextIndex]);
  }

  function prepareGalleryFigure(gallery, figure, prioritize) {
    if (!figure || figure.getAttribute('data-media-type') !== 'image') {
      return;
    }

    if (prioritize) {
      promoteGalleryFigureImages(figure);
      updateGalleryViewerAspectRatio(gallery, figure);
    }

    activateGalleryFigure(figure);
    preloadFollowingGalleryImage(gallery, figure);
  }

  function prepareSelectedGalleryFigure(gallery) {
    var selectedFigure = gallery.querySelector(
      '[data-gallery-viewer] [data-gallery-figure][data-gallery-selected="true"]'
    );

    if (selectedFigure && selectedFigure.getAttribute('data-media-type') === 'image') {
      prepareGalleryFigure(gallery, selectedFigure, true);
    }
  }

  function initializeGallery(gallery) {
    var viewer;
    var observer;

    if (initializedGalleries.has(gallery)) {
      return;
    }

    viewer = gallery.querySelector('[data-gallery-viewer]');
    if (!viewer) {
      return;
    }

    initializedGalleries.add(gallery);
    prepareSelectedGalleryFigure(gallery);

    observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var figure = mutation.target;

        if (
          figure instanceof HTMLElement &&
          figure.matches('[data-gallery-figure][data-gallery-selected="true"]')
        ) {
          prepareGalleryFigure(gallery, figure, true);
        }
      });
    });

    observer.observe(viewer, {
      attributes: true,
      subtree: true,
      attributeFilter: ['data-gallery-selected']
    });
    galleryObservers.set(gallery, observer);
  }

  function initializeGalleriesWithin(root) {
    eachWithin(root, gallerySelector, initializeGallery);
  }

  function unloadGalleriesWithin(root) {
    eachWithin(root, gallerySelector, function (gallery) {
      var observer = galleryObservers.get(gallery);

      if (observer) {
        observer.disconnect();
      }
      galleryObservers.delete(gallery);
      initializedGalleries.delete(gallery);
    });
  }

  /* Galleries inserted after load (for example product quickshop) */
  function initializeQuickshopContent(root) {
    initializeGalleryGeometryWithin(root);
    initializeGalleriesWithin(root);
    initializeGalleryThumbnailRovingWithin(root);
  }

  function initializeQuickshopObserver(root) {
    var observer;

    if (!root || quickshopObservers.has(root)) {
      return;
    }

    observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        toArray(mutation.addedNodes).forEach(function (node) {
          if (node.nodeType === 1) {
            initializeQuickshopContent(node);
          }
        });
      });
    });
    observer.observe(root, {
      childList: true
    });
    quickshopObservers.set(root, observer);
    initializeQuickshopContent(root);
  }

  function initializeQuickshopObserversWithin(root) {
    eachWithin(root, '[data-product-quickshop]', initializeQuickshopObserver);
  }

  function unloadQuickshopObserversWithin(root) {
    eachWithin(root, '[data-product-quickshop]', function (quickshop) {
      var observer = quickshopObservers.get(quickshop);

      if (observer) {
        observer.disconnect();
      }
      quickshopObservers.delete(quickshop);
    });
  }

  /* Shared legacy product tabs controller */
  function placeTabsTemplate(template) {
    var placeholderSelector;
    var anchorSelector;
    var target;
    var panel;
    var position;

    if (template.getAttribute('data-kk-tabs-template-placed') === 'true') {
      return;
    }

    placeholderSelector = template.getAttribute('data-kk-tabs-placeholder');
    anchorSelector = template.getAttribute('data-kk-tabs-anchor');
    target = placeholderSelector ? document.querySelector(placeholderSelector) : null;

    if (!target && anchorSelector) {
      target = document.querySelector(anchorSelector);
    }

    panel = template.content && template.content.firstElementChild;
    if (!target || !panel) {
      return;
    }

    position = template.getAttribute('data-kk-tabs-position') || 'beforebegin';
    target.insertAdjacentElement(position, panel);
    template.setAttribute('data-kk-tabs-template-placed', 'true');
    initializeProductTabs(panel);
  }

  function initializeTabsTemplatesWithin(root) {
    eachWithin(root, '[data-kk-product-tabs-template]', placeTabsTemplate);
  }

  function initializeProductTabs(root) {
    var delay;
    var initTimer;

    if (
      tabStates.has(root) ||
      tabInitTimers.has(root) ||
      root.getAttribute('data-kk-tabs-initialized') === 'true'
    ) {
      return;
    }

    delay = parseInt(root.getAttribute('data-kk-tabs-init-delay'), 10) || 0;
    root.setAttribute('data-kk-tabs-init-pending', 'true');

    initTimer = window.setTimeout(function () {
      tabInitTimers.delete(root);
      root.removeAttribute('data-kk-tabs-init-pending');

      if (document.documentElement.contains(root)) {
        attachProductTabs(root);
      }
    }, delay);

    tabInitTimers.set(root, initTimer);
  }

  function attachProductTabs(root) {
    var variant = root.getAttribute('data-kk-tabs-variant') || '5';
    var paddingTop = parseFloat(root.getAttribute('data-kk-tabs-padding-top')) || 0;
    var closeOthers = root.getAttribute('data-kk-tabs-close-others') === 'true';
    var openDefault = root.getAttribute('data-kk-tabs-open-default') === 'true';
    var entries = [];
    var resizeTimer = null;
    var resizeHandler;

    if (tabStates.has(root)) {
      return;
    }

    toArray(root.querySelectorAll('[data-kk-tabs-item]')).forEach(function (item) {
      var toggle = item.querySelector('[data-kk-tabs-toggle]');
      var answer = item.querySelector('[data-kk-tabs-answer]');
      var measure = item.querySelector('[data-kk-tabs-measure]');

      if (!toggle || !answer || !measure) {
        return;
      }

      toggle.setAttribute('aria-expanded', 'false');
      entries.push({
        item: item,
        toggle: toggle,
        answer: answer,
        measure: measure,
        arrow: item.querySelector('[data-kk-tabs-arrow]'),
        icon: item.querySelector('[data-kk-tabs-icon]'),
        closeTimer: null,
        openTimer: null,
        animationFrame: null,
        clickHandler: null
      });
    });

    function clearEntryTimers(entry) {
      window.clearTimeout(entry.closeTimer);
      window.clearTimeout(entry.openTimer);
      if (entry.animationFrame !== null) {
        window.cancelAnimationFrame(entry.animationFrame);
      }
      entry.closeTimer = null;
      entry.openTimer = null;
      entry.animationFrame = null;
    }

    function openAnswer(index) {
      var entry = entries[index];
      var height;

      if (!entry) {
        return;
      }

      clearEntryTimers(entry);
      height = entry.measure.offsetHeight;
      entry.toggle.setAttribute('aria-expanded', 'true');
      entry.answer.style.display = 'block';

      if (variant === '5') {
        entry.answer.style.opacity = '0';
        entry.item.classList.add('active');
        if (entry.arrow) {
          entry.arrow.style.transition = 'transform 0.2s cubic-bezier(0.4, 0, 0.2, 1)';
          entry.arrow.classList.add('active');
        }

        entry.animationFrame = window.requestAnimationFrame(function () {
          entry.animationFrame = null;
          entry.answer.style.transition = 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)';
          entry.answer.style.paddingTop = paddingTop + 'px';
          entry.answer.style.paddingBottom = '0px';
          entry.answer.style.height = height + 'px';
          entry.answer.style.opacity = '1';
        });
      } else {
        entry.openTimer = window.setTimeout(function () {
          entry.openTimer = null;
          entry.answer.style.paddingTop = paddingTop + 'px';
          entry.answer.style.paddingBottom = '0px';
          entry.answer.style.height = height + 'px';
          if (entry.arrow) {
            entry.arrow.style.setProperty('--rotate', '90deg');
          }
          if (entry.icon) {
            entry.icon.classList.add('active');
          }
        }, 0);
      }
    }

    function closeAnswer(index) {
      var entry = entries[index];
      var wasOpen;

      if (!entry) {
        return;
      }

      wasOpen = entry.toggle.getAttribute('aria-expanded') === 'true';
      clearEntryTimers(entry);
      entry.toggle.setAttribute('aria-expanded', 'false');

      if (!wasOpen && entry.answer.style.display === 'none') {
        return;
      }

      entry.answer.style.paddingTop = '0px';
      entry.answer.style.paddingBottom = '0px';
      entry.answer.style.height = '0px';

      if (variant === '5') {
        entry.answer.style.transition = 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)';
        entry.answer.style.opacity = '0';
        entry.item.classList.remove('active');
        if (entry.arrow) {
          entry.arrow.style.transition = 'transform 0.2s cubic-bezier(0.4, 0, 0.2, 1)';
          entry.arrow.classList.remove('active');
        }
      } else {
        if (entry.arrow) {
          entry.arrow.style.setProperty('--rotate', '0deg');
        }
        if (entry.icon) {
          entry.icon.classList.remove('active');
        }
      }

      entry.closeTimer = window.setTimeout(function () {
        entry.closeTimer = null;
        if (entry.toggle.getAttribute('aria-expanded') !== 'true') {
          entry.answer.style.display = 'none';
        }
      }, variant === '5' ? 250 : 300);
    }

    function closeAllExcept(index) {
      entries.forEach(function (entry, entryIndex) {
        if (entryIndex !== index) {
          closeAnswer(entryIndex);
        }
      });
    }

    entries.forEach(function (entry, index) {
      entry.clickHandler = function () {
        if (entry.toggle.getAttribute('aria-expanded') === 'true') {
          closeAnswer(index);
          return;
        }

        if (closeOthers) {
          closeAllExcept(index);
        }
        openAnswer(index);
      };

      entry.toggle.addEventListener('click', entry.clickHandler);
    });

    if (openDefault && entries.length) {
      openAnswer(0);
    }

    resizeHandler = function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        entries.forEach(function (entry) {
          if (entry.toggle.getAttribute('aria-expanded') === 'true') {
            entry.answer.style.transition = variant === '5' ?
              'height 0.2s cubic-bezier(0.4, 0, 0.2, 1)' :
              entry.answer.style.transition;
            entry.answer.style.height = entry.measure.offsetHeight + 'px';
          }
        });
      }, 250);
    };

    window.addEventListener('resize', resizeHandler);
    root.setAttribute('data-kk-tabs-initialized', 'true');
    tabStates.set(root, {
      destroy: function () {
        window.clearTimeout(resizeTimer);
        window.removeEventListener('resize', resizeHandler);
        entries.forEach(function (entry) {
          clearEntryTimers(entry);
          entry.toggle.removeEventListener('click', entry.clickHandler);
        });
        root.removeAttribute('data-kk-tabs-initialized');
      }
    });
  }

  function initializeTabsWithin(root) {
    eachWithin(root, '[data-kk-product-tabs]', initializeProductTabs);
  }

  function destroyProductTabs(root) {
    var initTimer = tabInitTimers.get(root);
    var state = tabStates.get(root);

    if (initTimer !== undefined) {
      window.clearTimeout(initTimer);
      tabInitTimers.delete(root);
    }
    root.removeAttribute('data-kk-tabs-init-pending');

    if (state) {
      state.destroy();
      tabStates.delete(root);
    }
  }

  function unloadTabsWithin(root) {
    var sectionIds = [];

    eachWithin(root, '[data-kk-product-tabs-template]', function (template) {
      var sectionId = template.getAttribute('data-kk-tabs-section-id');
      if (sectionId && sectionIds.indexOf(sectionId) === -1) {
        sectionIds.push(sectionId);
      }
    });

    eachWithin(root, '[data-kk-product-tabs]', function (tabs) {
      var sectionId = tabs.getAttribute('data-kk-tabs-section-id');
      if (sectionId && sectionIds.indexOf(sectionId) === -1) {
        sectionIds.push(sectionId);
      }
      destroyProductTabs(tabs);
    });

    if (!sectionIds.length) {
      return;
    }

    toArray(document.querySelectorAll('[data-kk-product-tabs]')).forEach(function (tabs) {
      var sectionId = tabs.getAttribute('data-kk-tabs-section-id');

      if (sectionIds.indexOf(sectionId) !== -1 && !root.contains(tabs)) {
        destroyProductTabs(tabs);
        tabs.remove();
      }
    });
  }

  /* Easify option tooltip portal */
  function initializeProductTooltip() {
    var tooltipIconSelector = '.tpo_option-tooltip-icon';
    var pad = 12;
    var gap = 10;
    var portal;
    var activeIcon = null;

    if (tooltipInitialized || !document.querySelector(tooltipIconSelector)) {
      return false;
    }

    tooltipInitialized = true;
    portal = document.querySelector('.ds-tooltip-portal');

    if (!portal) {
      portal = document.createElement('div');
      portal.className = 'ds-tooltip-portal';
      document.body.appendChild(portal);
    }

    function clamp(value, min, max) {
      return Math.max(min, Math.min(value, max));
    }

    function show(icon, html) {
      var iconRect;
      var portalRect;
      var left;
      var top;

      activeIcon = icon;
      portal.innerHTML = html;
      portal.classList.add('is-visible');
      iconRect = icon.getBoundingClientRect();
      portalRect = portal.getBoundingClientRect();
      left = iconRect.left + iconRect.width / 2 - portalRect.width / 2;
      left = clamp(left, pad, window.innerWidth - pad - portalRect.width);
      top = iconRect.bottom + gap;

      if (top + portalRect.height > window.innerHeight - pad) {
        top = iconRect.top - portalRect.height - gap;
      }

      top = clamp(top, pad, window.innerHeight - pad - portalRect.height);
      portal.style.left = left + 'px';
      portal.style.top = top + 'px';
    }

    function hide() {
      activeIcon = null;
      portal.classList.remove('is-visible');
    }

    function getTooltipParts(target) {
      var icon = target && target.closest ? target.closest(tooltipIconSelector) : null;
      var tooltip = icon && icon.closest('.tpo_option-tooltip');
      var content = tooltip && tooltip.querySelector('.tpo_option-tooltip-content');
      return icon && content ? { icon: icon, content: content } : null;
    }

    function repositionActiveTooltip() {
      var tooltip;
      var content;

      if (!activeIcon) {
        return;
      }

      tooltip = activeIcon.closest('.tpo_option-tooltip');
      content = tooltip && tooltip.querySelector('.tpo_option-tooltip-content');
      if (content) {
        show(activeIcon, content.innerHTML);
      }
    }

    document.addEventListener('mouseover', function (event) {
      var parts = getTooltipParts(event.target);
      if (!parts || (event.relatedTarget && parts.icon.contains(event.relatedTarget))) {
        return;
      }
      show(parts.icon, parts.content.innerHTML);
    });

    document.addEventListener('mouseout', function (event) {
      var parts = getTooltipParts(event.target);
      if (!parts || (event.relatedTarget && parts.icon.contains(event.relatedTarget))) {
        return;
      }
      hide();
    });

    document.addEventListener('click', function (event) {
      var parts = getTooltipParts(event.target);

      if (!parts) {
        hide();
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      show(parts.icon, parts.content.innerHTML);
    }, true);

    window.addEventListener('scroll', repositionActiveTooltip, { passive: true });
    window.addEventListener('resize', repositionActiveTooltip, { passive: true });
    return true;
  }

  function initializeWithin(root) {
    initializeQuickshopObserversWithin(root);
    initializeGalleryGeometryWithin(root);
    initializeGalleriesWithin(root);
    initializeGalleryThumbnailRovingWithin(root);
    initializePhotoSwipeThumbnailRoving();
    initializePhotoSwipeFocusGuard();
    initializeTabsTemplatesWithin(root);
    initializeTabsWithin(root);
    initializeProductTooltip();
  }

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    var thumbnail = target && target.closest('[data-gallery-thumbnail]');
    var gallery = thumbnail && thumbnail.closest(gallerySelector);
    var galleryIndex;
    var figure;

    if (!gallery) {
      return;
    }

    galleryIndex = thumbnail.getAttribute('data-gallery-index');
    figure = getGalleryFigures(gallery).find(function (item) {
      return item.getAttribute('data-gallery-index') === galleryIndex;
    });
    prepareGalleryFigure(gallery, figure, true);
  }, true);

  ['mouseover', 'focusin', 'click'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      var target = event.target instanceof Element ? event.target : null;
      var trigger = target && target.closest('[data-quickshop-trigger]');
      var productItem = trigger && trigger.closest('[data-product-item]');
      var quickshop = productItem && productItem.querySelector('[data-product-quickshop]');

      if (quickshop) {
        initializeQuickshopObserver(quickshop);
      }
    }, true);
  });

  document.addEventListener('easify:loaded', initializeProductTooltip);
  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    unloadGalleryGeometryWithin(event.target);
    unloadGalleriesWithin(event.target);
    unloadGalleryThumbnailRovingWithin(event.target);
    unloadQuickshopObserversWithin(event.target);
    unloadTabsWithin(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeWithin(document);
    });
  } else {
    initializeWithin(document);
  }
}());
